// Styles
import '@scss/variables.scss';
import '../../MapStyles/MapMenu.scss';

// Libraries
import { Button, Card, ToggleButtonGroup } from 'react-bootstrap';

// Store
import { useMapStore } from '../../MapStore/UseMapStore';

export function MapEditTabs() {
  const selected = useMapStore((state) => state.selected);
  const setSelected = useMapStore((state) => state.setSelected);
  const setClickEvent = useMapStore((state) => state.setClickEvent);

  return (
    <div className="objects-bar">
      <Card.Header>
        <ToggleButtonGroup
          type="radio"
          name="info-tabs"
          className="d-flex flex-row justify-content-between"
        >
          <Button
            className="d-flex flex-row align-items-center justify-content-center"
            variant={selected === 'overlay' ? 'primary' : 'secondary'}
            onClick={() => {
              selected === 'overlay' ? setSelected('') : setSelected('overlay');
              setClickEvent(null);
            }}
          >
            <i className="sonarIcon sonarIcon-map fs-md" style={{ marginRight: '8px' }} />
          </Button>
          <Button
            className="d-flex flex-row align-items-center justify-content-center"
            variant={selected === 'place' ? 'primary' : 'secondary'}
            onClick={() => {
              selected === 'place' ? setSelected('') : setSelected('place');
              setClickEvent(null);
            }}
          >
            <i className="sonarIcon sonarIcon-place fs-md" style={{ marginRight: '8px' }} />
          </Button>
          <Button
            className="d-flex flex-row align-items-center justify-content-center"
            variant={selected === 'gateway' ? 'primary' : 'secondary'}
            onClick={() => {
              selected === 'gateway' ? setSelected('') : setSelected('gateway');
              setClickEvent(null);
            }}
          >
            <i className="sonarIcon sonarIcon-gateway fs-md" style={{ marginRight: '8px' }} />
          </Button>
          <Button
            className="d-flex flex-row align-items-center justify-content-center"
            variant={selected === 'stationary' ? 'primary' : 'secondary'}
            onClick={() => {
              selected === 'stationary' ? setSelected('') : setSelected('stationary');
              setClickEvent(null);
            }}
          >
            <i
              className="sonarIcon sonarIcon-stationary-beacon fs-md"
              style={{ marginRight: '8px' }}
            />
          </Button>
        </ToggleButtonGroup>
      </Card.Header>
    </div>
  );
}
